export interface ExplainModule {
  name: ExplainModuleEnum;
  type?: UserModuleTypeEnum;
  expiration_date?: Date;
  permissions?: Permissions;
}

interface Permissions {
  plan: UserPlanEnum;
  nb_allowed_projects: number;
  nb_created_projects: number;
}

export enum UserModuleTypeEnum {
  TRIAL = 'trial',
  PAID = 'paid',
}
export enum UserPlanEnum {
  PRO = 'pro',
  BUSINESS = 'business',
  ENTERPRISE = 'enterprise',
}
export enum ExplainModuleEnum {
  TERRITORY_INTEL = 'territory_intel',
  TENDERS = 'tenders',
  RESPONSE = 'response',
}

export enum ExplainMainModuleEnum {
  TERRITORY_INTEL = 'territory_intel',
  TENDERS = 'tenders',
}

export interface DtoUserSession {
  api_token: string;
  email: string;
  first_name: string;
  group_account_id: number;
  id: number;
  last_name: string;
  modules: Array<ExplainModule>;
}

export class UserSession {
  id: number;
  groupAccountId: number;
  firstName: string;
  lastName: string;
  email: string;
  apiToken: string;
  modules: Array<ExplainModule>;

  constructor(userSession: DtoUserSession) {
    this.id = userSession.id;
    this.groupAccountId = userSession.group_account_id;
    this.firstName = userSession.first_name;
    this.lastName = userSession.last_name;
    this.email = userSession.email;
    this.apiToken = userSession.api_token;
    this.modules = userSession.modules;
  }
}

export interface DbUser {
  last_name: string;
  first_name: string;
}

export class User {
  firstName: string;
  lastName: string;

  constructor(dbUser: DbUser) {
    this.firstName = dbUser.first_name;
    this.lastName = dbUser.last_name;
  }
}
